module.exports = __webpack_public_path__ + "images/help/icon-twr47@2x-c22aafb4d2b731308275914b7b0b0257.png";